var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXAxis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_7926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.75C3.5 1.33579 3.16421 1 2.75 1C2.33579 1 2 1.33579 2 1.75V20.25C2 20.6642 2.33579 21 2.75 21H21C21.4142 21 21.75 20.6642 21.75 20.25C21.75 19.8358 21.4142 19.5 21 19.5H3.5V1.75Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.535 16.6243C18.6907 16.4686 18.9419 16.4673 19.0959 16.6213L22.4431 19.9685C22.5971 20.1225 22.5958 20.3736 22.44 20.5294L19.0566 23.9128C18.9009 24.0685 18.6498 24.0699 18.4957 23.9158C18.3417 23.7618 18.343 23.5107 18.4987 23.3549L21.2015 20.6522L13.5587 20.6934C13.3397 20.6946 13.1631 20.518 13.1643 20.2989C13.1655 20.0799 13.344 19.9014 13.563 19.9002L21.2058 19.859L18.532 17.1852C18.378 17.0312 18.3793 16.78 18.535 16.6243Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11828 7.11828C9.276 6.96057 9.5317 6.96057 9.68941 7.11828L12.5 9.92888L15.3106 7.11828C15.4683 6.96057 15.724 6.96057 15.8817 7.11828C16.0394 7.276 16.0394 7.5317 15.8817 7.68941L13.0711 10.5L15.8817 13.3106C16.0394 13.4683 16.0394 13.724 15.8817 13.8817C15.724 14.0394 15.4683 14.0394 15.3106 13.8817L12.5 11.0711L9.68941 13.8817C9.5317 14.0394 9.276 14.0394 9.11828 13.8817C8.96057 13.724 8.96057 13.4683 9.11828 13.3106L11.9289 10.5L9.11828 7.68941C8.96057 7.5317 8.96057 7.276 9.11828 7.11828Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_7926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXAxis);
export default __webpack_public_path__ + "static/media/x-axis.350c660b.svg";
export { ForwardRef as ReactComponent };